<!-- @format -->

<template>
    <ListadoSelect
      v-model="Seleccionado"
      :tipo="tipo"
      tipo-icono="fas fa-sitemap"
      :service="Service"
     
    />
  </template>
  
  <script>
  import Service from "@/api-services/puestos.service";
  import ListadoSelect from "@/Componentes/Listados/Select.vue";
  export default {
    name: "PuestosSelect",
    components: {
      ListadoSelect,
    },
    props: {
      tipo: {
        type: String,
        required: false,
        default: "puesto",
      },
    },
    data() {
      return {
  
        Seleccionado: null,
      };
    },
    computed: {
      Service() {
        return Service;
      },
  
    },
  
  };
  </script>